import { SbuDto, PlantDto } from './../_models';
import { AuthorizedUserInfoDto } from './../_models/user.models';
import axios from 'axios';
import { APP_CONFIGS } from '../_constants/config.constants';

const isAuthorizedUser = (): boolean => {
    const user = sessionStorage.getItem(APP_CONFIGS.USER_SESSION_KEY);
    return !!user;
}

const getAuthorizedUser = (): AuthorizedUserInfoDto => {
    const user = sessionStorage.getItem(APP_CONFIGS.USER_SESSION_KEY);
    return JSON.parse(atob(user));
}

const getAuthorizedUserFactories = (): SbuDto[] => {
    const factories = localStorage.getItem(APP_CONFIGS.USER_FACTORIES_SESSION_KEY);
    return JSON.parse(atob(factories));
}

const getAuthorizedUserPlants = (): PlantDto[] => {
    const sbus = localStorage.getItem(APP_CONFIGS.USER_FACTORIES_SESSION_KEY);
    const sbuList = JSON.parse(atob(sbus))
    let plants = [];
    if (sbuList) {
        sbuList.forEach(sbu => {
            sbu.plants.forEach(plant => plants.push(plant))
        })
    }
    return plants;
}

export const authorizationService = {
    isAuthorizedUser,
    getAuthorizedUser,
    getAuthorizedUserFactories,
    getAuthorizedUserPlants
}
